import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UserRoleRule } from '../../../models/feature-flag.model';
import { AbstractListRuleComponent } from './abstract-list-rule.component';

/**
 * Component for building and managing user role-based targeting rules
 */
@Component({
  selector: 'cbre-user-role-rule',
  templateUrl: './user-role-rule.component.html',
  styleUrls: ['./user-role-rule.component.scss'],
  standalone: false,
})
export class UserRoleRuleComponent extends AbstractListRuleComponent<UserRoleRule> {
  /**
   * The rule type identifier
   */
  protected ruleType = 'userRole';

  /**
   * Common regions for quick selection
   * This could be expanded or loaded from configuration
   */
  protected commonItems = ['D&T', 'US Broker', 'US Researcher'];

  /**
   * Error message for duplicates
   */
  protected duplicateErrorMessage = 'This user role is already in the list';

  constructor(protected override fb: FormBuilder) {
    super(fb);
  }
}
